import Vue from "vue";
// import Vue from 'vue/dist/vue.common.js';
import App from "./App.vue";
import store from "./store";
import "../public/menu.js";
import vmodal from "vue-js-modal";
import "./assets/style.scss";
import "vue-select/dist/vue-select.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueScrollTo from "vue-scrollto";
import "@fortawesome/fontawesome-svg-core/styles.css";

Vue.use(VueScrollTo, {
  container: "body",
  duration: 250,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

import vSelect from "vue-select";

Vue.component("v-select", vSelect);
Vue.config.productionTip = false;
library.add(faCheck);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(vmodal);

import RoHAnchorButton from "@/components/RoHAnchorButton.vue";
import RoHAnchorList from "@/components/RoHAnchorList.vue";
import RoHHero from "@/components/RoHHero.vue";
import RoHHeader from "@/components/RoHHeader.vue";
import RoHFooter from "@/components/RoHFooter.vue";
import RoHFactsList from "@/components/RoHFactsList.vue";
import RoHContactForm from "@/components/RoHContactForm.vue";
import RoHButton from "@/components/RoHButton.vue";
import RoHSectionHeadline from "@/components/RoHSectionHeadline.vue";

const components = {
  RoHAnchorButton,
  RoHAnchorList,
  RoHButton,
  RoHContactForm,
  RoHFactsList,
  RoHFooter,
  RoHHeader,
  RoHHero,
  RoHSectionHeadline,
};

new Vue({
  store,
  components,
  el: "#app",
});
